import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Accordion, Alert, Badge, Button, Carousel, Col, Container, Form, Image, InputGroup, Row } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import FollowButton from './FollowButton';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { rankingBgColor,rankingOpacity} from "./common/RankingUtil";
import Masonry from 'react-masonry-css';
import Tile from './common/Tile';
import Thumb from './common/Thumb';
import UserInfoPopup from './common/UserInfoPopup';
import EventViewPopup from './EventViewPopup';

const Events = () => {
    async function getImageListWithTagOrderByRandom(tag,page){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/randomTag/",{tag:tag}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserSetting(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getRankingImage(tag,page){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/rankingEvent/",{tag:tag,page:page}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserInfo(userIdOrDisplayId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/"+userIdOrDisplayId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getEvent(groupId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/event/info/"+groupId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getEventMember(groupId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/event/member/"+groupId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function search(tag,page){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/tag/",{tag:tag,page:page}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    const [eventInfo, setEventInfo] = useState([])
    const [eventMember, setEventMember] = useState([])
    const [userSetting, setUserSetting] = useState([])
    const [messageList,setMessageList] = useState([])
    const [odaiImageList,setOdaiImageList] = useState([])
    const [last6MonthAvg,setLast6MonthAvgList] = useState([])
    const [contestImageList,setContestImageList] = useState([])
    const [imageList,setImageList] = useState([])
    const [randomImageList,setRandomImageList] = useState([])
    const [rankingImageList,setRankingImageList] = useState([])
    const [followUserImage,setFollowUserImage] = useState([...Array(0)])
    const [followUserMessage,setFollowUserMessage] = useState('')
    const [odai,setOdai] = useState([])
    const [tomorrowOdai,setTomorrowOdai] = useState([])
    const [imagePage,setImagePage] = useState(1)
    const [oldGeneralOrAI,setOldGeneralOrAI] = useState([])
    const [isEnd,setIsEnd] = useState(false)
    const [showViewPopup,setShowViewPopup] = useState(false)

    // ランキング用のユーザ情報ポップアップ
    const [displayId,setDisplayId] = useState()
    const [selfIntroduction,setSelfIntroduction] = useState()
    const [follow,setFollow] = useState()
    const [follower,setFollower] = useState()

    // パラメータ
    let param = useParams()
    let groupId = param.group_id

    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "1000px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (imagePage * 30 - 1) ){
                    setImagePage(imagePage+1)
                }
              }
        })
    }, options);

    useEffect(() => {
        getEvent(groupId).then(r => {
            if(r.result){
                setEventInfo(r)
                // タイトル設定
                document.querySelector("title").textContent = r.info.title + " - " + t("common.siteName")
                // ランキング
                getRankingImage(r.info.tag,1).then(r => {
                    if(r.result){
                        setRankingImageList(r.data.splice(0,100))
                    }
                })
                setIsEnd(new Date(r.info.to_datetime) < new Date())
                search(r.info.tag,imagePage).then(r => {
                    if(r.result){
                        if(r.data.length > 0){
                            setImageList(imageList.concat(r.data))
                        } else {
                            if(imagePage === 1){
                                setImageList([])
                                dialog("","まだ投稿がありません。1枚目を投稿しませんか？")
                            }
                        }
                    } else {
                        setImageList([])
                        dialog(t("common.confirm"),r.errors)
                    }
                })
            }
        })
        getEventMember(groupId).then(r => {
            if(r.result){
                setEventMember(r.data)
            }
        })
    },[imagePage])

    useEffect(() => {
        // ユーザ設定
        getUserSetting().then(r => {
            if(r.result){
                setUserSetting(r)
            }
        })
    },[])

    useEffect(() => {
        if(loginInfo.result){
            // 連続投稿の表示減らす
            setOmitContinuous(loginInfo.renzoku === 1)
            // タイルモード
            setTileMode(loginInfo.tile === 1)
        }
    },[loginInfo])

    // 画像遅延ロード
    useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageList,rankingImageList,followUserImage])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    const [omitContinuous,setOmitContinuous] = useState(false)
    const [tileMode,setTileMode] = useState(true)

    const breakpointColumnsObj = {
        default: 7,
        1400: 6,
        1200: 5,
        992: 4,
        768: 3,
        576: 2,
    }
    return(
    <>
    <Header />
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        {showViewPopup ? <EventViewPopup groupId={groupId} switch={setShowViewPopup} i={Math.random() * 1000000} /> : ""}
        <Category />
        <Container style={{}} className='text-center'>
            {eventInfo.info !== undefined ? (
                <Image
                    height={300}
                    src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/event/post/s/"+eventInfo.detail[0].id+".webp"}
                    onClick={() => {
                        setShowViewPopup(true)
                    }}
                />
            ) : ""}
        </Container>
        <Container className='mt-3 mb-3'>
        <h3>{eventInfo.info ? eventInfo.info.title : ""}</h3>
        <p>開催期間: {eventInfo.info ? eventInfo.info.from_datetime : ""} ～ {eventInfo.info ? eventInfo.info.to_datetime : ""}</p>
        <Accordion flush style={{border:"1px solid #CCCCCC"}} className="mb-3">
            <Accordion.Item eventKey="0">
                <Accordion.Header>概要</Accordion.Header>
                    <Accordion.Body>
                        <p style={{whiteSpace:"pre"}}>
                            {eventInfo.info ? eventInfo.info.description : ""}
                        </p>
                        <p>開催期間</p>
                        <p>{eventInfo.info ? eventInfo.info.from_datetime : ""} ～ {eventInfo.info ? eventInfo.info.to_datetime : ""}</p>
                    </Accordion.Body>
            </Accordion.Item>
        </Accordion>
        {eventMember.length > 0 ? (
        <Container className='text-center'>
            <p style={{fontSize:"24px"}}>審査員</p>
            <Container className='d-flex justify-content-center'>
                {eventMember.map(d => {
                    return <Link to={"/user/"+d.user_id} target='_blank' className='m-3'>
                                <Container style={{pointer:"cursor"}}>
                                    <Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+".jpg"} width={150} style={{borderRadius:"75px"}} /><br />
                                    {d.user_name}
                                </Container>
                            </Link>
                })}
            </Container>
        </Container>
        ) : ""}
        {isEnd && false ? <>
            イベントは終了しました。<br />
            沢山のご応募ありがとうございました！<br />
            <Container style={{borderRadius:"5px",backgroundColor:"#CFE2FF",border:"1px solid #B6D4FE"}} className={"mt-3" + (groupId === "295ca6dc-b1f9-419a-bdb1-1a8be597ade5" ? "" : "d-none")}>
                <h2>審査員賞①</h2>
                審査員：ぶるぺん/blue.pen5805
                <Container style={{width:"300px"}}>
                    <Tile data={
                        {
                            "group_id": "1a8fd1c6-b194-4a38-a49a-70e7e1245e10",
                            "booking_datetime": "0000-00-00 00:00:00",
                            "create_datetime": "2023-10-16 19:04:51",
                            "id": "6b439379-402d-4d47-8afc-4f27b787c2eb"
                        }
                    } i={-2} dialog={dialog} />
                </Container>
                <h3>メイドにゃん</h3>
                <LinkContainer to={"/user/7a34645b-577d-407c-be39-360881d881d1"} style={{cursor:"pointer"}}>
                    <p>
                        <Image loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/profile/7a34645b-577d-407c-be39-360881d881d1_s.jpg'} style={{borderRadius:"25px",display:"inline"}} width="50px" height="50px" />
                        &nbsp;
                        <span style={{fontSize:"24px"}}>kohakuryu</span>
                    </p>
                </LinkContainer>
                <b>審査員コメント</b>
                <p>
                    かっこいいのからかわいいのからついでに変なのまでいろいろありましたが、<br />
                    やっぱ動物といえばカワイイのが鉄板だろということで、猫のかわいさがいたるところから表現されているよう感じたこの作品を選ばさせていただきました。<br />
                    動物サイコー
                </p>
            </Container>
            <Container style={{borderRadius:"5px",backgroundColor:"#CFE2FF",border:"1px solid #B6D4FE"}} className={"mt-3" + (groupId === "295ca6dc-b1f9-419a-bdb1-1a8be597ade5" ? "" : "d-none")}>
                <h2>審査員賞②</h2>
                審査員：Tea＠AI Creator
                <Container style={{width:"300px"}}>
                    <Tile data={
                        {
                            "group_id": "23ad56d9-caa3-421d-bd0a-db6951c5eeb9",
                            "booking_datetime": "0000-00-00 00:00:00",
                            "create_datetime": "2023-10-15 16:44:19",
                            "id": "d12928bf-3a2f-4acb-883e-8d6a190d5bd8"
                        }
                    } i={-1} dialog={dialog} />
                </Container>
                <h3>孤高の王</h3>
                <LinkContainer to={"/user/d4aa356a-866a-4dcd-9b07-fc5e6e63b7fa"} style={{cursor:"pointer"}}>
                    <p>
                        <Image loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/profile/d4aa356a-866a-4dcd-9b07-fc5e6e63b7fa_s.jpg'} style={{borderRadius:"25px",display:"inline"}} width="50px" height="50px" />
                        &nbsp;
                        <span style={{fontSize:"24px"}}>Elsa</span>
                    </p>
                </LinkContainer>
                <b>審査員コメント</b>
                <p>
                    コンテストの1枚を選ぶのって本当に難しいですね🥺<br />
                    たった1枚の絵にストーリーが感じられる作品が好きで、今回これを選ばさせていただきました。<br />
                    中央にライオンが座っているシンプルな構図ですが、このシンプルな形だからこそ情報が全て『ライオン』に集約されていて、<br />
                    その視線の先から何を思って見ているのか、感じているのか、考えているのか、某ライオン映像作品を彷彿させる感じで凄く好きな1枚です
                </p>
            </Container>
        </> : ""}
        </Container>
        {true ? (
            <>
        <Container className='mt-4 mb-3 d-flex justify-content-between' style={{fontSize:"24px",fontWeight:"bold",display:"block",borderLeft:"10px solid lightblue",borderBottom:"3px solid lightblue"}}>
            <span><RIcon.FaCrown style={{paddingBottom:"5px",color:"orange"}} /> {t("category.ranking")}</span>
        </Container>
        <Container className='d-flex flex-row justify-content-start flex-wrap w-100' style={{display:"block"}}>
            {rankingImageList.map((data,i) => {
                let random = Math.random() * 100000
                let rank = i + 1
            return <Container style={{position:"relative",width:"180px"}} className="p-0 mb-3" key={i}>
                        <Container style={{position:"relative",width:"180px",height:"180px",padding:0}}
                            onMouseOver={() => {
                                document.querySelectorAll(".ranking-detail-"+i).forEach((e) => {
                                    e.style.opacity = "1"
                                    e.style.transition = "0.1s"
                                })
                            }}
                            onMouseLeave={() => {
                                document.querySelectorAll(".ranking-detail-"+i).forEach((e) => {
                                    e.style.opacity = "0"
                                    e.style.transition = "0.1s"
                                })
                            }}
                        >
                            <Badge bg="danger" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 2 ? "block":"none"}}>
                                R-18
                            </Badge>
                            <Badge bg="danger" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 3 ? "block":"none"}}>
                                R-18G
                            </Badge>
                            <Badge bg="secondary" style={{position:"absolute",zIndex:"1",bottom:"20px",left:"20px",display:data.img_count > 1 ? "block":"none"}}>
                                <Icon.CollectionFill /> {data.img_count}
                            </Badge>
                            <Badge className={"ranking-detail-"+i} bg="secondary" style={{position:"absolute",bottom:"20px",left:"55px",zIndex:1,backgroundColor:"#FFFFFF",opacity:0}}>
                                <Icon.HandThumbsUp /> {data.favorite_count}
                            </Badge>
                            <Badge className={"ranking-detail-"+i} bg="secondary" style={{position:"absolute",bottom:"20px",left:"90px",zIndex:1,backgroundColor:"#FFFFFF",opacity:0}}>
                                <Icon.Eye /> {data.pv_count}
                            </Badge>
                            <div className='text-center' style={{position:"absolute",backgroundColor:rankingBgColor(rank),opacity:rankingOpacity(rank),width:"40px",height:"40px",zIndex:"1",top:"10px",left:"10px",fontWeight:"bold",fontSize:"24px"}} />
                            <div className='text-center' style={{position:"absolute",color:"#FFFFFF",width:"40px",height:"40px",zIndex:"1",top:"10px",left:"10px",fontWeight:"bold",fontSize:"24px"}}>
                                {rank}
                            </div>
                            <FavoriteIcon style={{cursor:"pointer",position:"absolute",zIndex:"1",bottom:"20px",right:"20px"}} type="image" id={data.group_id} favorite={data.favorite} dialog={dialog} />
                            <Link to={"/image/"+(data.group_id)}>
                                <Image data-no={i} loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/post/t/'+(data.id)+ApiFetch.API_THUMB_EXT} style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%"}} className="p-2" key={i} />
                            </Link>
                        </Container>
                        <Container style={{fontWeight:"bold",fontSize:"15px",whiteSpace:"nowrap",overflow:"hidden"}}><Link to={"/image/"+(data.group_id)} style={{textDecoration:"none"}}>{data.title}</Link></Container>
                        <Container style={{whiteSpace:"nowrap",overflow:"hidden"}}>
                            <Link to={"/user/"+(data.user_id)} style={{textDecoration:"none",cursor:"pointer"}}
                            onMouseOver={(e) => {
                                getUserInfo(data.user_id).then(r => {
                                    document.getElementById("sub-"+random).style.display = "block"
                                    setDisplayId(r.display_id)
                                    setSelfIntroduction(r.self_introduction)
                                    setFollow(r.follow)
                                    setFollower(r.follower)
                                })
                            }}
                            >
                                <Image loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/profile/'+(data.user_id)+'_s.jpg?'+data.hash} style={{borderRadius:"12px",display:data.user_id ? "inline" : "none"}} width="24px" height="24px" /> {data.user_name}
                            </Link>
                        </Container>
                        <UserInfoPopup data={data} displayId={displayId} selfIntroduction={selfIntroduction} follow={follow} follower={follower} random={random} />
                    </Container>
            })}
        </Container>
        </>) : ""}
        <Container className='mt-4 mb-3 d-flex justify-content-between' style={{fontSize:"24px",fontWeight:"bold",borderLeft:"10px solid lightblue",borderBottom:"3px solid lightblue"}}>
            <span>応募作品</span>
        </Container>
        <Container>
            <Container className='d-flex p-0'>
                <InputGroup className='m-2' style={{width:"300px"}}>
                    <InputGroup.Checkbox aria-label="Checkbox for following text input" style={{cursor:"pointer"}} defaultChecked={omitContinuous} onClick={(e) => setOmitContinuous(e.currentTarget.checked)} />
                    <Form.Control type="text" value={t("common.deduceConsecutiveSubmissions")} readOnly />
                </InputGroup>
                <InputGroup className='m-2' style={{width:"200px"}}>
                    <InputGroup.Checkbox style={{cursor:"pointer"}} checked={tileMode} onClick={(e) => {
                        setTileMode(e.currentTarget.checked)
                        }} />
                    <Form.Control type="text" value={t("common.tileMode")} readOnly />
                </InputGroup>
            </Container>
        </Container>
        {tileMode ? (
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
                >
                {imageList.map((data,i) => {
                    if(i === 30) return
                    if(omitContinuous && param.general_or_ai !== "test" && i > 0 && imageList[i-1].user_id === data.user_id){
                        return <span data-no={i} className="lazy" key={i}></span>
                    }
                return <Tile data={data} i={i} dialog={dialog} key={i} observer={observer} />

                })}
            </Masonry>
        ) : (
        <Container className='d-flex flex-row justify-content-start flex-wrap w-100'>
            {imageList.map((data,i) => {
                if(i === 30) return
                if(omitContinuous && param.general_or_ai !== "test" && i > 0 && imageList[i-1].user_id === data.user_id){
                    return <span data-no={i} className="lazy" key={i}></span>
                }
            return <Thumb data={data} i={i} dialog={dialog} key={i} observer={observer} />
            })}
        </Container>
        )}
        <Container>
        
        </Container>
        <Footer />
    </div>
    </>
    )
}

export default Events;
